export default "__VITE_ASSET__3e4a346d__"